import { createSlice } from "@reduxjs/toolkit";
import {
  getProducts,
  addNewProduct,
  updateProduct,
  deleteProducts,
  setProductFlag,
  getProductById,
  getHotProducts,
  getMyProducts,
  downloadProducts,
} from "./thunk";
import { toast } from "react-toastify";

export const initialState = {
  products: null,
  hotProducts: [],
  myProducts: [],
  product: null,
  error: {},
  paginationList: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
    totalOrdered: 0,
    totalReady: 0,
    totalCancelled: 0,
    totalPendingOrders: 0,
    totalActive: 0,
    totalInactive: 0,
    totalInStock: 0,
    totalOutOfStock: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalStockNotifications: 0,
    total: 0,
  },
  paginationHot: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
    totalOrdered: 0,
    totalReady: 0,
    totalCancelled: 0,
    totalPendingOrders: 0,
    totalActive: 0,
    totalInactive: 0,
    totalInStock: 0,
    totalOutOfStock: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalStockNotifications: 0,
    total: 0,
  },
  paginationMyProducts: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
    totalOrdered: 0,
    totalReady: 0,
    totalCancelled: 0,
    totalPendingOrders: 0,
    totalActive: 0,
    totalInactive: 0,
    totalInStock: 0,
    totalOutOfStock: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalStockNotifications: 0,
    total: 0,
  },
};

const ProductsSlice = createSlice({
  name: "ProductsSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getProducts.fulfilled, (state, action) => {
      state.products = action.payload.data;
      state.paginationList = action.payload.pagination;
    });

    builder.addCase(getProducts.rejected, (state, action) => {
      state.error = action.error || null;
    });

    builder.addCase(getProductById.fulfilled, (state, action) => {
      state.product = action.payload.data;
    });

    builder.addCase(getProductById.rejected, (state, action) => {
      state.error = action.error || null;
    });

    builder.addCase(getHotProducts.fulfilled, (state, action) => {
      state.hotProducts = action.payload.data;
      state.paginationHot = action.payload.pagination;
    });

    builder.addCase(getHotProducts.rejected, (state, action) => {
      state.error = action.error || null;
    });

    builder.addCase(getMyProducts.fulfilled, (state, action) => {
      state.myProducts = action.payload.data;
      state.paginationMyProducts = action.payload.pagination;
    });

    builder.addCase(getMyProducts.rejected, (state, action) => {
      state.error = action.error || null;
    });

    builder.addCase(addNewProduct.fulfilled, (state, action) => {
      state.products.push(action.payload);
    });

    builder.addCase(addNewProduct.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateProduct.fulfilled, (state, action) => {
      state.products = state.products.map((product) =>
        product._id.toString() === action.payload.data._id.toString()
          ? { ...product, ...action.payload.data }
          : product
      );
    });

    builder.addCase(updateProduct.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(deleteProducts.fulfilled, (state, action) => {
      state.products = (state.products || []).filter(
        (product) =>
          product._id.toString() !== action.payload.product.toString()
      );
    });

    builder.addCase(deleteProducts.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(setProductFlag.fulfilled, (state, action) => {
      /* state.products = state.products.map((product) =>
        product.pro_id === action.payload.data.pro_id
          ? { ...product, ...action.payload.data }
          : product
      );*/
    });

    builder.addCase(setProductFlag.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(downloadProducts.pending, (state) => {
      toast.dismiss();
      toast.loading("Preparing download...", {
        position: "top-center",
        autoClose: false,
      });
      state.error = null;
    });

    builder.addCase(downloadProducts.fulfilled, (state, action) => {
      toast.dismiss();
      // Open the download link in a new tab
      if (!action.payload.success) {
        toast.error(action.payload.message, {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      } else {
        toast.success("Download ready!", {
          position: "top-center",
          autoClose: 3000,
        });
        window.open(action.payload.message, "_blank");
      }
    });
    builder.addCase(downloadProducts.rejected, (state, action) => {
      state.error = action.payload.error || null;
      toast.dismiss();
      toast.error(action.payload.error, {
        position: "top-center",
        autoClose: 3000,
      });
    });
  },
});

export default ProductsSlice.reducer;
